import { ColumnHelper } from '@tanstack/react-table'
import { HStack, QuickTip, Text } from 'govwell-ui'
import { AIChatbotFAQFragment } from 'types/graphql'

export const AIChatbotFAQCountColumn = (columnHelper: ColumnHelper<AIChatbotFAQFragment>) =>
  columnHelper.accessor((aiChatbotFAQ) => aiChatbotFAQ.count, {
    id: 'count',
    header: () => (
      <HStack gap={1}>
        <Text className="inline font-semibold"># Times Asked</Text>
        <QuickTip content="The number of times this question has been asked on the public portal. This value is refreshed nightly." />
      </HStack>
    ),
    cell: (info) => info.getValue(),
    enableSorting: false,
  })
